import { render, staticRenderFns } from "./TeamBuildingStageText.vue?vue&type=template&id=050d7d76&"
import script from "./TeamBuildingStageText.vue?vue&type=script&lang=js&"
export * from "./TeamBuildingStageText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports